export default __webpack_public_path__ + "static/media/logo.eafa3bc1.svg";